import { useState, useEffect } from "react";
import axios from "axios";

/**
 * useHighlightsAuth
 *
 * The highlights page is fully public — no login required to view it.
 * This hook does a silent background check to see if the visitor is already
 * logged in, so the CTA slide can offer the right option:
 *   - "loggedIn"  → go straight to the dashboard
 *   - "loggedOut" → they have an account, offer a login link
 *   - "guest"     → no account, show the demo signup form
 *
 * On error (network issue, 403 etc.) we default to "guest" so the page
 * always renders correctly.
 *
 * @returns {{ status: "ready", authState: "loggedIn"|"loggedOut"|"guest" }}
 */
export function useHighlightsAuth() {
  const [authState, setAuthState] = useState("guest");

  useEffect(() => {
    axios
      .get("/api/user-info/")
      .then((res) => {
        if (res.data && res.data.email) {
          setAuthState("loggedIn");
        } else {
          setAuthState("loggedOut");
        }
      })
      .catch(() => {
        // 401/403 = not logged in, network error = treat as guest
        setAuthState("guest");
      });
  }, []);

  return { status: "ready", authState };
}
